import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const OidcCallbackRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') ?? '';

  const OIDC_CALLBACK_MESSAGE = 'Sample OIDC Callback Routing! This is a demo.';

  return (
    <div className="text-center mt-8">
      <h1>{OIDC_CALLBACK_MESSAGE}</h1>
      <p>
        <span className="inline-block break-all bg-gray-100 px-2 py-0.5 rounded ml-1 font-mono">
          {code}
        </span>
        <button
          className="ml-2 px-2 py-1 bg-blue-400 text-white rounded hover:bg-blue-600 transition-colors"
          onClick={() => navigator.clipboard.writeText(code)}
        >
          Copy Code
        </button>
      </p>
    </div>
  );
};
